import { Box, Button, FormField, Heading, List, ResponsiveContext, Tab, Tabs, Text, TextArea, TextInput } from "grommet";
import { debounce } from "lodash";
import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { usePermission } from "../account/AccountStore";
import { AliasViewModel, searchAliases } from "../aliases/AliasStore";
import { AliasTile } from "../aliases/AliasTile";
import { addParticipant, removeParticipant } from "../seasons/SeasonsStore";
import { TeamRow } from "../teams/TeamsManagement";
import { getTeamMembers, searchTeams, TeamViewModel } from "../teams/TeamsStore";
import TournamentBlock from "../tournaments/TournamentBlock";
import { AddTournamentParticipantRequest, AliasTournamentParticipantViewModel, RemoveTournamentParticipantRequest, TournamentParticipantViewModel, updateParticipant, UpdateTournamentParticipantRequest } from "../tournaments/TournamentsStore";
import { CreateEntry, GetOrganizationInvite, OrganizationEntryAliasTeamParticipantViewModel, OrganizationEntryViewModel, OrganizationInviteViewModel, RemoveOrganizationEntry, UpdateOrganizationEntry, UpdateOrganizationInvite } from "./RegistrationStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Organization } from "../organizations/OrganizationStore";
import CustomButton from "../components/CustomButton";
import { AliasRow } from "../aliases/AliasRow";
import SkeletonWrapper from "../components/SkeletonWrapper";
import StyledModal from "../components/StyledModel";
import OrganizationSearch from "../organizations/OrganizationSearch";
import TeamDetails from "../teams/TeamDetails";
import Avatar from "react-avatar";
import { format, parseJSON } from "date-fns";
import { DateTimePicker, FormatDateTime } from "../components/DateTimePicker";

const edit = <FontAwesomeIcon icon={["fad", "pencil"]}></FontAwesomeIcon>;

const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;
const addTeam = <FontAwesomeIcon icon={["fad", "user-plus"]}></FontAwesomeIcon>;

const OrganizationInviteEdit = () => {
    const { id } = useParams();
    const size = useContext(ResponsiveContext);
    const hasWritePermission = usePermission("sport:management");

    const [invite, setInvite] = React.useState({} as OrganizationInviteViewModel);

    const [name, setName] = React.useState("");
    const [content, setContent] = React.useState("");
    const [startDate, setStartDate] = React.useState(new Date().toISOString());
    const [endDate, setEndDate] = React.useState(new Date().toISOString());
    const [showDateEdit, setShowDateEdit] = React.useState(false);

    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        load();
    }, [id]);

    const load = () => {
        setIsLoading(true);
        GetOrganizationInvite(id).then((res) => {
            setInvite(res.result);

            setName(res.result.name);
            setContent(res.result.content);
            setStartDate(res.result.startDate);
            setEndDate(res.result.endDate);

            setIsLoading(false);
        });
    };

    const update = () => {
        UpdateOrganizationInvite({
            organizationInviteID: invite.id,
            name,
            content,
            startDate,
            endDate,
        }).then(() => {
            load();
        });
    };

    return (
        <SkeletonWrapper loading={isLoading}>
            {invite.id && (
                <Box direction="row" gap="small">
                    <TournamentBlock tournament={invite.tournament}></TournamentBlock>
                    <Box fill>
                        <Heading level={3}>{invite.name}</Heading>

                        <FormField label="Name">
                            <TextInput size="xs" value={name} onChange={(e) => setName(e.target.value)} />
                        </FormField>
                        <FormField label="Content">
                            <TextArea size="xs" value={content} onChange={(e) => setContent(e.target.value)} />
                        </FormField>
                        <Box border="bottom" margin={{ bottom: "small" }}>
                            <Text margin={{ left: "small" }}>Invitations Open</Text>
                            <Text margin={{ left: "small", top: "small" }}>{FormatDateTime(parseJSON(startDate), "yyyy/MM/dd")}</Text>
                        </Box>
                        <Box margin={{ bottom: "small" }}>
                            <Text margin={{ left: "small" }}>Invitations Close</Text>
                            <Box direction="row" justify="between" border="bottom">
                                <Text margin={{ left: "small", top: "small" }}>{FormatDateTime(parseJSON(endDate), "yyyy/MM/dd")}</Text>
                                <Box hoverIndicator="background-front" onClick={() => setShowDateEdit(true)} pad="small">
                                    <FontAwesomeIcon icon={["fad", "edit"]}></FontAwesomeIcon>
                                </Box>
                            </Box>
                        </Box>

                        {hasWritePermission && !invite.tournament.locked && (
                            <Box direction="row" gap="small" justify="end">
                                <CustomButton label="Update" icon={addTeam} onClick={() => update()}></CustomButton>
                            </Box>
                        )}

                        <StyledModal isOpen={showDateEdit} setIsOpen={setShowDateEdit}>
                            <Box gap="small" align="center">
                                <Box>
                                    <Text margin={{ left: "small" }}>Invitations Open</Text>
                                    <DateTimePicker value={startDate} onChange={setStartDate}></DateTimePicker>
                                </Box>
                                <Box>
                                    <Text margin={{ left: "small" }}>Invitations Close</Text>
                                    <DateTimePicker value={endDate} onChange={setEndDate}></DateTimePicker>
                                </Box>
                                <Box direction="row" justify="end" fill>
                                    <Button label="Confirm" onClick={() => setShowDateEdit(false)}></Button>
                                </Box>
                            </Box>
                        </StyledModal>
                    </Box>
                </Box>
            )}
        </SkeletonWrapper>
    );
};

export default OrganizationInviteEdit;
